module.exports = __webpack_public_path__ + "static/media/print-apps.92589c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/print-apps.jpg
// module id = 1222
// module chunks = 0